module.exports = __webpack_public_path__ + "assets/img/device-logs.10e6470a.svg";